import useCoolOnClickOutside from 'react-cool-onclickoutside';

import type { Callback, Options } from 'react-cool-onclickoutside';

export function useOnClickOutside(handler: Callback<Event>, options?: Options | undefined) {
  const result = useCoolOnClickOutside(handler, options);
  return result;
}
